// extracted by mini-css-extract-plugin
export default {"icons_container":"options-bar_icons_container__6wGEU"};